exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* InsuranceForm Style Sheet */\n\n._1CTVPiBZHesZsaWtoYiDmT{\n    font-style: normal;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 23px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    letter-spacing: 0.25px;\n    padding: 2rem 0rem;\n    color: #142A39;\n}\n\n.viXnJJErnmkcSnB7pt1zg {\n    width: 100%;\n    border: 1px solid #142a396c;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 4px;\n    height: 40px;\n    padding: 10px;\n}\n\n._3XAGVH22PbduXb1s86_w0u{\n    padding-bottom: 2rem;\n}\n\n._2AhCFzWeeWfX_bmU5Jx3gC {\n    margin-top: -1rem;\n    margin-bottom: 1rem;\n}", ""]);

// exports
exports.locals = {
	"title": "_1CTVPiBZHesZsaWtoYiDmT",
	"testInput": "viXnJJErnmkcSnB7pt1zg",
	"pageContainer": "_3XAGVH22PbduXb1s86_w0u",
	"insuranceMedicareNote": "_2AhCFzWeeWfX_bmU5Jx3gC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/InsuranceForm/InsuranceForm.styles.module.css
// module id = 9743
// module chunks = 23